<template>
  <div class="flex flex-col w-full pt-4 px-1 min-h-screen space-y-6">
    <div>
      <h2
        class="text-base sm:text-lg text-center lg:text-left font-semibold text-gray-900"
      >
        Retailer Purchase History
      </h2>
    </div>

    <div
      class="flex relative rounded-lg border w-full sm:w-4/5 border-gray-200 justify-between items-center mx-auto"
    >
      <input
        type="text"
        class="w-full px-4 py-2 border-0 ml-2 outline-none text-sm"
        v-model.trim="retailer"
        placeholder="Search using phone number"
        @keyup.enter="getRetailerPurchaseHistory"
      />
      <i
        class="fas fa-search ml-1 p-2 text-lg text-expressgray hover:text-express cursor-pointer"
        @click="getRetailerPurchaseHistory"
      ></i>
    </div>

    <div
      v-if="!isLoading"
      class="flex flex-col bg-white border border-gray-100 rounded-lg shadow-sm w-full text-expressgray mb-5 h-full"
    >
      <div class="w-full overflow-x-auto">
        <table class="w-full text-sm">
          <tr class="border-b border-gray-200 text-center bg-gray-50">
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Name</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Business name</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Mobile</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Old Wallet Balance</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">New Wallet Balance</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Recharge Amount</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Currency</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Payment Reference</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Added By</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Country</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Date</th>
          </tr>
          <tbody v-if="retailer_purchase_history_list.length > 0">
            <tr
              class="border-b border-gray-100 text-center hover:bg-gray-50"
              v-for="(item, index) in retailer_purchase_history_list"
              :key="index"
            >
              <td class="px-3 py-3 whitespace-nowrap">{{ item.name }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.business_name }}</td>
              <td class="px-3 py-3 whitespace-nowrap capitalize">{{ item.phone }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.old_balance }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.new_balance }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.amount }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.currency }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.reference }}</td>
              <td class="px-3 py-3 whitespace-nowrap capitalize">{{ item.added_by }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.country }}</td>
              <td class="px-3 py-3 capitalize whitespace-nowrap">
                {{ item.created_at }}
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <p class="whitespace-nowrap font-semibold text-sm ml-2">
                No data available
              </p>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-5 mx-5" v-else>
      <loading message="Loading, please wait"></loading>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useToast } from "vue-toast-notification";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const $toast = useToast();
const $router = useRouter();

const retailer = ref(null);
const isLoading = ref(false);

const retailer_purchase_history_list = computed(
  () => store.getters["admins/retailer_purchase_history"]
);

async function getRetailerPurchaseHistory() {
  if (!checkNumber(retailer.value).status) {
    $toast.info("Please provide valid phone number", {
      position: "top-right",
    });
    return;
  }
  isLoading.value = true;

  store.commit("admins/setRetailersPurchaseHistoryEmpty");

  await store.dispatch("admins/get_retailer_purchase_history", {
    phone: checkNumber(retailer.value).digit,
    toast: $toast,
    router: $router,
  });

  isLoading.value = false;
}

function checkNumber(num) {
  console.log(num);
  const phone = num.slice(-10);
  if (!isNaN(num) && num.length >= 10) {
    return {
      status: true,
      digit: Number(phone),
    };
  }
  return {
    status: false,
  };
}
</script>

<style></style>
